import { Alert } from "@/ui/index";
import React from "react";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

type ApprovalRequiredProps = {
  className: string;
};
export const ApprovalRequiredAlert: React.FC<ApprovalRequiredProps> = ({
  className = ""
}) => {
  const { currentResource } = useReserveForm();
  if (!currentResource?.is_approvable) return;
  return (
    <div className={className}>
      <Alert
        variant="warning"
        canDismiss={false}
        alertTitle="Approval Required"
        alertMessage="An office admin will approve or deny this reservation after you submit it."
        className="px-4 py-2"
      />
    </div>
  );
};
